import React, { PureComponent } from 'react'
import hoistNonReactStatic from 'hoist-non-react-statics'
import branch from 'branch-sdk'
import Cookie from 'aria-viewer/utils/cookie'

const DEEPLINK_TRIGGER_DELAY = 2000 //milliseconds

function withNativeAppDeeplink(WrappedComponent) {
    class NativeAppDeepLink extends PureComponent {
        constructor(props) {
            super(props)
            this.deepLinkTriggered = 0
            this.fallbackAttempted = false
        }

        componentWillUnmount() {
            this.deepLinkFallbackTimeout && clearTimeout(this.deepLinkFallbackTimeout)
        }

        triggerDeeplink = ({ deepLinkAnalyticsCB, startInMode }) => {
            /**
             * Deeplink is triggered on landscape in ClientVR
             * Ensure we do not trigger deepLink's too often
             */

            let now = new Date().getTime()
            let triggerDelta = now - this.deepLinkTriggered
            if (triggerDelta < DEEPLINK_TRIGGER_DELAY) return
            this.deepLinkTriggered = now

            let { location, client, currentStop } = this.props
            let deeplink = {}

            //record analytics on mixpanel
            deepLinkAnalyticsCB && deepLinkAnalyticsCB()

            if (location) {
                const { loc_id, owner_id, vr_app } = location
                var ua = navigator.userAgent.toLowerCase()
                var isAndroid = ua.indexOf('android') > -1 && ua.indexOf('mobile') > -1
                var _hasAppConfig =
                    vr_app && ((isAndroid && vr_app.status_android) || (!isAndroid && vr_app.status_ios))

                if (client && client.isAppAvailable && _hasAppConfig) {
                    var appScheme = `youvisitwwww${owner_id}`
                    var bundleId = `com.youvisit.hybridvr${owner_id}`
                    if (isAndroid && vr_app.android_bundle_id && vr_app.android_bundle_id.length > 0)
                        bundleId = vr_app.android_bundle_id
                    if (!isAndroid && vr_app.ios_bundle_id && vr_app.ios_bundle_id.length > 0)
                        bundleId = vr_app.ios_bundle_id

                    var appleId = vr_app.appleid

                    var name = `${location.name} Mobile App`

                    if (isAndroid) {
                        deeplink = {
                            isClientApp: client && client.isAppAvailable,
                            inst_id: owner_id,
                            loc_id: loc_id,
                            url: `intent://open?&inst_id=${owner_id}&loc_id=${loc_id}&stop_id=0&#Intent;scheme=${appScheme};end`,
                            fallbackUrl: `market://details?id=${bundleId}&referrer=%26inst_id%3D${owner_id}%26loc_id%3D${loc_id}%26stop_id%3D0`,
                            appName: name,
                        }
                    } else {
                        deeplink = {
                            isClientApp: client && client.isAppAvailable,
                            inst_id: owner_id,
                            loc_id: loc_id,
                            url: `${appScheme}:open?&inst_id=${owner_id}&loc_id=${loc_id}&stop_id=0`,
                            params: `&inst_id=${owner_id}&loc_id=${loc_id}&stop_id=0`,
                            fallbackUrl: `https://itunes.apple.com/us/app/youvisit-vr/id${appleId}`,
                            appName: name,
                        }
                    }
                } else {
                    // For bundled deep link via branch io
                    this.launchBranchIOLink({ loc_id, owner_id, branchKey: vr_app.branchKey })
                    return
                }
            }

            /* Determine if we have ClientVR injected function */
            if (typeof window.yvLaunchNativeVR != 'undefined') {
                /* Client VR Override to Native */
                var stopid =
                    currentStop && currentStop.stopid && 'panorama' == currentStop.main_media_type
                        ? currentStop.stopid
                        : 0
                var seekTime = 0
                //start in mode or default to immersive
                window.yvLaunchNativeVR(deeplink.inst_id, deeplink.loc_id, stopid, seekTime, startInMode || 'immersive')
            } else {
                this._deeplinkToApp(deeplink)
            }
        }

        render() {
            return <WrappedComponent {...this.props} triggerDeeplink={this.triggerDeeplink} />
        }

        triggerAppLaunch = deeplink => {
            window.top.location = deeplink.url
            if (deeplink.fallbackUrl) {
                this.deepLinkFallbackTimeout = setTimeout(() => {
                    window.top.location = deeplink.fallbackUrl
                    //just incase the fallback is surpressed.
                    this.fallbackAttempted = true
                }, 2000)
            }
        }

        launchBranchIOLink = ({ owner_id, loc_id, branchKey }) => {
            branch.init(branchKey)

            branch.link(
                {
                    channel: 'mobile_web',
                    feature: 'dashboard',
                    data: {
                        $deeplink_path: `open?&inst_id=${owner_id}&loc_id=${loc_id}`,
                        inst_id: owner_id,
                        loc_id: loc_id,
                    },
                },
                (err, link) => {
                    window.top.location = link
                }
            )
        }

        /**
         * Deep link to mobile app
         * @param deeplink configuration for deeplinking
         */
        _deeplinkToApp = deeplink => {
            if (deeplink.url) {
                //Set cookie for bounceback
                Cookie.set('deepLink_lastParamString', deeplink.params, 30)

                //Check if user confirmed app
                var hasAppKey = `hasApp_${deeplink.inst_id}`

                if (Cookie.get(hasAppKey) == false || Cookie.get(hasAppKey) == null) {
                    //Trigger app prompt
                    if (confirm(`Do you have the ${deeplink.appName}?`)) {
                        //Set cookies
                        Cookie.set(hasAppKey, true, 30)

                        /* Attempt to deeplink to App */
                        this.triggerAppLaunch(deeplink)
                    } else {
                        //Set cookies
                        Cookie.set(hasAppKey, false, 30)
                        //Go to app store
                        if (deeplink.fallbackUrl) {
                            window.top.location = deeplink.fallbackUrl
                        }
                    }
                } else {
                    /* Attempt to deeplink to App */
                    this.triggerAppLaunch(deeplink)
                }
            }
        }
    }
    // then, re-add it's component statics (that aren't react lifecycle methods)
    const ComponentWithStatics = hoistNonReactStatic(NativeAppDeepLink, WrappedComponent)
    return ComponentWithStatics
}
export default withNativeAppDeeplink
